import { tokens, Text, Button } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import NoDetailsSvg from '../../resources/images/no-details.svg';

const S = {
  Illustration: styled.img`
    padding-bottom: ${tokens.spacer.x3};
  `,
  MainSection: styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  `,
  Title: styled(Text)`
    margin: 0 0 ${tokens.spacer.x1};
  `,
  Description: styled(Text)`
    margin: 0;
  `,
  Button: styled(Button)`
    margin-top: ${tokens.spacer.x3};
  `,
};

export interface BlockedViewProps {
  illustration?: string;
  title: string;
  description: string;
  button: {
    text: string;
    onClick: () => void;
    navigateTo: string;
    isExternal?: boolean;
  };
}

export function NoDetailsAvailable({
  illustration = NoDetailsSvg,
  title,
  description,
  button: { text: buttonText, onClick, navigateTo, isExternal },
}: BlockedViewProps): JSX.Element {
  return (
    <S.MainSection>
      <S.Illustration src={illustration} alt="" />
      <S.Title as="h2" textType="header5">
        {title}
      </S.Title>
      <S.Description as="p" textType="body1" textColor="text_light">
        {description}
      </S.Description>
      <S.Button as="a" href={navigateTo} onClick={onClick} isExternal={isExternal}>
        {buttonText}
      </S.Button>
    </S.MainSection>
  );
}
